"use client";
import { AppShell } from "@/app/_providers/AppShell";
import { AxiosSetup } from "@/app/_providers/AxiosSetup";
import { ReverbPermissions } from "@auth/components/ReverbPermissions";
import IntercomProvider from "@/intercom/IntercomProvider";
import { MantineProvider } from "@mantine/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // These endpoints don't fail transiently — a failure is the server's
      // real answer, not a network blip retrying would fix. TanStack's
      // default (3 retries, exponential backoff) just leaves screens stuck on
      // a loader for several extra seconds before showing the real error.
      // Individual queries can still opt into `retry: false` when even one
      // retry isn't warranted (e.g. a 404 that means "no data yet").
      retry: 1,
    },
  },
});

interface Props {
  children: React.ReactNode;
}

export function AppProviders({ children }: Props) {
  return (
    <MantineProvider>
      <AxiosSetup />
      <ReverbPermissions />
      <AppShell>
        <QueryClientProvider client={queryClient}>
          {children}
          <ReactQueryDevtools initialIsOpen={false} position="bottom" />
        </QueryClientProvider>
      </AppShell>
      <IntercomProvider />
    </MantineProvider>
  );
}
